import { useContext, useEffect } from "react";
import { AuthContext } from "./authProvider.mjs";
import { useNavigate, useLocation } from "react-router-dom";
import PageShell from "./components/PageShell.mjs";
import { rememberReturnPath } from "./auth/returnPath.mjs";


const AuthRequired = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // So a link from an email still reaches its page after signing in.
      rememberReturnPath(location.pathname + location.search);
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname, location.search]);

  // Rendered in the page frame, so the band is already in place while the
  // session check resolves instead of a bare spinner page flashing first.
  if (isLoading) {
    return (
      <PageShell>
        <div className="bg-white rounded-xl shadow-lg py-16 flex flex-col items-center justify-center">
          <div className="w-10 h-10 border-4 border-gray-200 border-t-stanford-red rounded-full animate-spin mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </PageShell>
    );
  }

  return isAuthenticated ? children : null;
};


export default AuthRequired;

